import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { cognitoRedirectUrl } from '@app/shared/auth/auth.config';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;

  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();
    let authReq = request;

    if (token) {
      authReq = this.addTokenHeader(request, token);
    }

    return next.handle(authReq).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse && error.status === 401) {
          return this.handle401Error(authReq, next);
        }
        return throwError(() => error);
      }),
    );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;

      return this.authService.refreshToken().pipe(
        switchMap((authResult) => {
          this.isRefreshing = false;
          this.authService.handleRefreshResponse(authResult);
          const newToken = this.authService.getToken();
          return next.handle(this.addTokenHeader(request, newToken!));
        }),
        catchError((err) => {
          this.isRefreshing = false;
          // Le refresh a échoué après un 401 initial :
          // on force la déconnexion quelle que soit la cause de l'échec
          // (refresh token invalide, réseau, 5xx Cognito).
          this.authService.clear();
          window.location.href = cognitoRedirectUrl;
          return throwError(() => err);
        }),
      );
    } else {
      return throwError(() => new Error('Token refresh already in progress'));
    }
  }

  private addTokenHeader(request: HttpRequest<any>, token: string) {
    return request.clone({
      headers: request.headers.set('Authorization', token),
    });
  }
}
